import { SVGProps } from 'react';

const Driver = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 7c0 2.762-2.238 5-5 5S7 9.762 7 7s2.238-5 5-5 5 2.238 5 5M2 19.5c0-3.325 6.663-5 10-5 3.338 0 10 1.675 10 5V22h-2.927a7.503 7.503 0 0 0-14.146 0H2zM16.331 22H7.67A5 5 0 0 1 12 19.5a5 5 0 0 1 4.331 2.5"
      clipRule="evenodd"
    />
  </svg>
);
export default Driver;
